import { render } from "./NewUnitMalfunctionReport.vue?vue&type=template&id=1ef9c7a7&scoped=true"
import script from "./NewUnitMalfunctionReport.vue?vue&type=script&lang=js"
export * from "./NewUnitMalfunctionReport.vue?vue&type=script&lang=js"

import "./NewUnitMalfunctionReport.vue?vue&type=style&index=0&id=1ef9c7a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef9c7a7"]])

export default __exports__